import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import "../Blogs/Postd.css"; // Importing the external CSS

const Postd = () => {
  const textRef = useRef(null); // Reference to the text container
  const sectionRef = useRef(null); // Reference to the section to calculate scroll position
  const [hasScrolled, setHasScrolled] = useState(false); // Track if section has been scrolled through

  // Function to split the text into spans for each letter
  const splitText = (text) => {
    return text.split(" ").map((word, wordIndex) => (
      <span key={wordIndex} className="word-db">
        {word.split("").map((letter, letterIndex) => (
          <span key={letterIndex} className="letter-db">
            {letter}
          </span>
        ))}
      </span>
    ));
  };

  useEffect(() => {
    const text = textRef.current;
    const letters = text.querySelectorAll(".letter-db");
    const section = sectionRef.current;

    // Set initial scale and opacity for letters
    gsap.set(letters, {
      scale: 1,
      opacity: 1,
    });

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const sectionTop = section.getBoundingClientRect().top;
      const sectionHeight = section.offsetHeight;
      const scrollPercentage = (scrollY - sectionTop) / sectionHeight;

      if (scrollPercentage >= 0 && scrollPercentage <= 1) {
        letters.forEach((letter, index) => {
          gsap.to(letter, {
            scale: 1 + scrollPercentage * 0.4,
            opacity: 1 - scrollPercentage * 0.5,
            ease: "power2.out",
            delay: index * 0.05,
          });
        });

        gsap.to(text, {
          scale: 1 + scrollPercentage * 0.9,
          opacity: 1 - scrollPercentage * 0.5,
          ease: "power2.out",
        });
      } else if (scrollPercentage > 1 && !hasScrolled) {
        setHasScrolled(true);
      }

      if (scrollPercentage <= 1 && hasScrolled) {
        letters.forEach((letter, index) => {
          gsap.to(letter, {
            scale: 1,
            opacity: 1 - (1 - scrollPercentage) * 0.5,
            ease: "power2.out",
            delay: index * 0.05,
          });
        });

        gsap.to(text, {
          scale: 1,
          opacity: 1,
          ease: "power2.out",
        });
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasScrolled]);

  return (
    <section ref={sectionRef} className="post-db">
      <img src="/blogd.webp" alt="Poster" className="poster-image-db" />
      <div className="overlay-db">
        <h1 ref={textRef} className="text-db">
          {splitText("Our Blog Details")}
        </h1>
      </div>
    </section>
  );
};

export default Postd;
